import React from 'react'
import { memo, useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import { useDispatch, useSelector } from "react-redux";
import { toAbsoluteUrl } from "../../../Utils/_helpers";
import { DropdownTopbarItemToggler } from "../../../Utils/_partials/dropdowns";
import { InputGroupFilter } from "../../components/InputGroupFilter";
import * as auth from "../../modules/Auth/_redux/authRedux";
import * as helpers from "../../util/helpers";
import DatePickerCRM from "./column-formatters/DatePickerCRM";

export const resetCRM = (
  auth,
  dispatch,
  resetToDefaultDate,
  searchFieldData
) => {
  const changelog = {
    lead_statuses: JSON.parse(JSON.stringify([...auth.i_lead_statuses])),
    agent_names_crm_filter: [],
    datepicker_crm_filter: [],
  };

  if (
    searchFieldData.agent_names_crm_filter &&
    searchFieldData.agent_names_crm_filter.length > 0
  ) {
    searchFieldData.agent_names_crm_filter.map((s, i) => {
      s.selected = false;
    });
    changelog.agent_names_crm_filter = [
      ...searchFieldData.agent_names_crm_filter,
    ];
  }

  dispatch(auth.actions.Clear({ changelog: changelog, module: "crm" }));
  dispatch(auth.actions.CheckFiltersState({ filter_type: "crmFiltersState" }));
};

const CRMHeaderFilters = (props) => {
  const myRefname = useRef(null);
  const dispatch = useDispatch();

  const [clearFilterFlag, setClearFilterFlag] = useState(0);

  const crmFiltersState = useSelector((state) => {
    return state.auth.crmFiltersState;
  });

  const handleClick = () => {
    myRefname.current.click();
  };

  const agent_names_crm_filter = useSelector((state) => {
    return state.auth.agent_names_crm_filter
      ? state.auth.agent_names_crm_filter
      : [];
  });

  const datepicker_crm_filter = useSelector((state) => {
    return state.auth.datepicker_crm_filter
      ? state.auth.datepicker_crm_filter
      : [];
  });

  const handleClearFilters = () => {
    let searchFieldData = {
      agent_names_crm_filter: agent_names_crm_filter,
      datepicker_crm_filter: datepicker_crm_filter,
    };
    setStatus(null);
    resetCRM(auth, dispatch, false, searchFieldData);
    handleClick();
    setClearFilterFlag(clearFilterFlag + 1);
  };

  const [status, setStatus] = useState(null);

  const handleApplySearch = () => {
    setStatus(null);
    dispatch(auth.actions.ApplySearch({ module: "crm" }));
    handleClick();
  };

  const [
    followUpDatePickerModalState,
    setFollowUpDatePickerModalState,
  ] = useState(false);

  const [isShown, setIsShown] = useState(false);
  const [counter, setCounter] = useState(0);

  useEffect(() => {
    if (followUpDatePickerModalState) setCounter(1);
  }, [followUpDatePickerModalState, isShown]);

  const onToggleHandler = (isOpen, event, meta) => {
    setIsShown(!isShown);
    if (isOpen && !followUpDatePickerModalState) {
      setIsShown(true);
    } else if (counter) {
      setIsShown(true);
      setCounter(0);
    } else {
      setIsShown(false);
    }
  };

  return (
    <>
      <Dropdown
        drop="down"
        className="logs-filter head-filter-dd"
        show={isShown}
        onToggle={onToggleHandler}
      >
        <Dropdown.Toggle
          as={DropdownTopbarItemToggler}
          id="dropdown-toggle-calendar-filter"
        >
          <div
            ref={myRefname}
            className="d-none d-lg-flex filter-btn pl-3 pr-1 pt-2 pb-2"
            onClick={() => {}}
          >
            <div className="inactive-ficon mr-2">
              <img
                alt=""
                src={toAbsoluteUrl("/media/sr/icons/inactive-filter-icon.svg")}
              />
            </div>
            <div className="active-ficon mr-2">
              <img
                alt=""
                src={toAbsoluteUrl("/media/sr/icons/active-filter-icon.svg")}
              />
            </div>
            <div className="mr-2">Filters</div>
            <div className="down-arrow">
              <img
                alt=""
                src={toAbsoluteUrl("/media/sr/icons/filter-down.svg")}
              />
            </div>
            <div className="up-arrow">
              <img
                alt=""
                src={toAbsoluteUrl("/media/sr/icons/filter-up.svg")}
              />
            </div>
          </div>
          <div
            ref={myRefname}
            className="d-flex d-lg-none mob-filter-btn filter-btn pl-3 pr-1 pt-2 pb-2"
          >
            <div className="inactive-ficon mr-2">
              <img
                alt=""
                src={toAbsoluteUrl("/media/sr/icons/inactive-filter-icon.svg")}
              />
            </div>
            <div className="active-ficon mr-2">
              <img
                alt=""
                src={toAbsoluteUrl("/media/sr/icons/active-filter-icon.svg")}
              />
            </div>
            <div className="mr-2">Filters</div>
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu className="filter-dropdown-menu">
          <ul className="list-unstyled p-5 mb-0">
            <li className="title mb-1">
              <div
                className="mt-0 mb-0 mr-1"
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Button
                  style={{ widths: "59px", fontSize: "12px" }}
                  className="sr-btn pl-6 pr-6 mr-3"
                  onClick={() => {
                    handleApplySearch();
                  }}
                  disabled={crmFiltersState == 200 ? false : true}
                >
                  Apply
                </Button>
                <Button
                  style={{ widths: "59px", fontSize: "12px" }}
                  className="outline-btn pl-6 pr-6"
                  onClick={handleClearFilters}
                >
                  Clear
                </Button>
              </div>
            </li>
          </ul>
          <div className="filter-divider"></div>
          {status && (
            <div className="filter-error-alert m-4">
              <div>
                <a
                  href="/#"
                  onClick={(e) => {
                    e.preventDefault();
                    setStatus(null);
                  }}
                >
                  <img
                    alt=""
                    className="exclamation-icon"
                    src={toAbsoluteUrl("/media/sr/icons/error-exclamation.svg")}
                  />
                </a>
              </div>
              <div className="error-text">{status}</div>
            </div>
          )}

          <InputGroupFilter
            filterState={"crmFiltersState"}
            initialOpen={true}
            filter_key={"lead_statuses"}
            filter_title={"LEAD STATUS"}
          />

          {(helpers.isAdmin() || helpers.isSuperVisor()) && (
            <DatePickerCRM
              filterState={"crmFiltersState"}
              filter_key={"datepicker_crm_filter"}
              clearFilterFlag={clearFilterFlag}
              filter_title={"FOLLOW UP"}
              initialOpen={false}
              followUpDatePickerModalState={setFollowUpDatePickerModalState}
            />
          )}
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default memo(
  CRMHeaderFilters,
  (prevProps, nextProps) => prevProps !== nextProps
);
